import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../Supabase/SupabaseClient';
import BrandArrow from '../ui/BrandArrow';
import {
  CATEGORIAS_SERVICIOS,
  agruparPorCategoria,
  urlServicio,
} from '../../config/catalogoServicios';
import { getSiteAsset, useSiteAssets } from '../../utils/useSiteAssets';
import './ServiceCategoryContainer.css';

const WHATSAPP = '3816818108';

/* Foto de respaldo local por si la URL del bucket no carga */
const FALLBACK_IMG = '/images/hero.png';

const openService = (item, navigate) => {
  if (item.slug) {
    navigate(urlServicio({ slug: item.slug }));
    return;
  }
  const msg = `Hola SC Group! Quiero información sobre "${item.label}".`;
  window.open(
    `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`,
    '_blank',
    'noopener,noreferrer'
  );
};

function ServiceMenuCard({ cat, imageUrl, isOpen, onToggle, onOpen, onClose, onSelectItem }) {
  const [imgSrc, setImgSrc] = useState(imageUrl);

  useEffect(() => {
    setImgSrc(imageUrl);
  }, [imageUrl]);

  const handleImgError = () => {
    if (imgSrc !== FALLBACK_IMG) setImgSrc(FALLBACK_IMG);
  };

  return (
    <article
      className={`service-menu-card${isOpen ? ' is-open' : ''}${cat.id === 'estudio' ? ' service-menu-card--static' : ''}`}
      onMouseEnter={onOpen}
      onMouseLeave={onClose}
    >
      <div className="smc__top">
        <button
          type="button"
          className="smc__toggle"
          onClick={onToggle}
          aria-expanded={isOpen}
          aria-controls={`smc-panel-${cat.id}`}
        >
          <span className="smc__title">{cat.title}</span>
          <BrandArrow direction="up-right" className="smc__arrow" />
        </button>

        <div id={`smc-panel-${cat.id}`} className="smc__panel" aria-hidden={!isOpen}>
          <div className="smc__panel-inner">
            <div className="smc__panel-body">
            <ul className="smc__list">
              {cat.items.map((item) => (
                <li key={item.label}>
                  <button
                    type="button"
                    className="smc__item"
                    onClick={() => onSelectItem(item)}
                  >
                    <span className="smc__item-text">
                      <span className="smc__item-label">{item.label}</span>
                      {item.note && <span className="smc__item-note">{item.note}</span>}
                    </span>
                    {item.options ? (
                      <span className="smc__opts">
                        {item.options.map((o) => (
                          <span className="smc__opt" key={o}>
                            {o}
                          </span>
                        ))}
                      </span>
                    ) : null}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      </div>

      <div className="smc__media" onClick={onOpen}>
        {imgSrc && (
          <img
            className="smc__media-img"
            src={imgSrc}
            alt=""
            loading="lazy"
            decoding="async"
            draggable={false}
            onError={handleImgError}
          />
        )}
        <span className="smc__corner smc__corner--tl" aria-hidden="true" />
        <span className="smc__corner smc__corner--tr" aria-hidden="true" />
        <span className="smc__corner smc__corner--bl" aria-hidden="true" />
        <span className="smc__corner smc__corner--br" aria-hidden="true" />
      </div>
    </article>
  );
}

function ServiceCategoryContainer() {
  const [openId, setOpenId] = useState(null);
  const [categorias, setCategorias] = useState(CATEGORIAS_SERVICIOS);
  const [cargando, setCargando] = useState(true);
  const assets = useSiteAssets();
  const navigate = useNavigate();

  useEffect(() => {
    let activo = true;

    const cargar = async () => {
      const { data, error } = await supabase
        .from('servicios')
        .select('id, nombre, slug, categoria, orden, nota, opciones, activo')
        .eq('activo', true)
        .order('orden', { ascending: true });

      if (!activo) return;

      if (!error && data && data.length > 0) {
        setCategorias(
          agruparPorCategoria(data).map((grupo) => ({
            id: grupo.id,
            title: grupo.titulo,
            imageUrl: grupo.imagen,
            items: grupo.items.map((item) => ({
              label: item.nombre,
              note: item.nota,
              options: item.opciones,
              slug: item.slug,
            })),
          }))
        );
      }
      setCargando(false);
    };

    cargar();
    return () => {
      activo = false;
    };
  }, []);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));
  const close = (id) => setOpenId((prev) => (prev === id ? null : prev));

  return (
    <section className="svc">
      <div className="svc__bg" aria-hidden="true">
        <div className="svc__bg-blob svc__bg-blob--1" />
        <div className="svc__bg-blob svc__bg-blob--2" />
      </div>

      <div className="svc__inner">
        <div className="svc__header" data-aos="fade-up">
          <h2 className="svc__title">
            Servicios
          </h2>
    
        
        </div>

        <div className="svc__grid" data-aos="fade-up" data-aos-delay="150" aria-busy={cargando}>
          {categorias.map((cat) => (
            <ServiceMenuCard
              key={cat.id}
              cat={cat}
              imageUrl={getSiteAsset(assets, `categoria.${cat.id}`) || cat.imageUrl}
              isOpen={openId === cat.id}
              onToggle={() => toggle(cat.id)}
              onOpen={() => setOpenId(cat.id)}
              onClose={() => close(cat.id)}
              onSelectItem={(item) => openService(item, navigate)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default ServiceCategoryContainer;